import ProcessSidebar from '@components/sentinel/ProcessSidebar/ProcessSidebar';
import { Outlet, useLocation } from 'react-router';

import './SentinelLayout.css';

export default function SentinelLayout() {
	const location = useLocation();

	const isHome = location.pathname === '/sentinel';
	const showSidebar = !isHome;

	return (
		<div id="sentinel-layout">
			<section className="sentinel-content">
				<Outlet />
			</section>
			{showSidebar && (
				<aside className="sentinel-sidebar">
					<ProcessSidebar />
				</aside>
			)}
		</div>
	);
}
